export const API_URL =
  'https://raw.githubusercontent.com/happypeter/vhome/master/data'



// WEBPACK FOOTER //
// ./src/constants/ApiConstants.js